export enum RequestErrorCode {
  MissingPrompt = "MissingPrompt",
  CorruptPrompt = "CorruptPrompt",
  KudosValidationError = "KudosValidationError",
  NoValidActions = "NoValidActions",
  InvalidSize = "InvalidSize",
  InvalidPromptSize = "InvalidPromptSize",
  TooManySteps = "TooManySteps",
  Profanity = "Profanity",
  ProfaneWorkerName = "ProfaneWorkerName",
  ProfaneBridgeAgent = "ProfaneBridgeAgent",
  ProfaneWorkerInfo = "ProfaneWorkerInfo",
  ProfaneUserName = "ProfaneUserName",
  ProfaneUserContact = "ProfaneUserContact",
  ProfaneAdminComment = "ProfaneAdminComment",
  ProfaneTeamName = "ProfaneTeamName",
  ProfaneTeamInfo = "ProfaneTeamInfo",
  TooLong = "TooLong",
  TooLongWorkerName = "TooLongWorkerName",
  TooLongUserName = "TooLongUserName",
  NameAlreadyExists = "NameAlreadyExists",
  WorkerNameAlreadyExists = "WorkerNameAlreadyExists",
  TeamNameAlreadyExists = "TeamNameAlreadyExists",
  PolymorphicNameConflict = "PolymorphicNameConflict",
  ImageValidationFailed = "ImageValidationFailed",
  SourceImageResolutionExceeded = "SourceImageResolutionExceeded",
  SourceImageSizeExceeded = "SourceImageSizeExceeded",
  SourceImageUrlInvalid = "SourceImageUrlInvalid",
  SourceImageUnreadable = "SourceImageUnreadable",
  InpaintingMissingMask = "InpaintingMissingMask",
  SourceMaskUnnecessary = "SourceMaskUnnecessary",
  UnsupportedSampler = "UnsupportedSampler",
  UnsupportedModel = "UnsupportedModel",
  ControlNetUnsupported = "ControlNetUnsupported",
  ControlNetSourceMissing = "ControlNetSourceMissing",
  ControlNetInvalidPayload = "ControlNetInvalidPayload",
  SourceImageRequiredForModel = "SourceImageRequiredForModel",
  UnexpectedModelName = "UnexpectedModelName",
  TooManyUpscalers = "TooManyUpscalers",
  ProcGenNotFound = "ProcGenNotFound",
  InvalidAestheticAttempt = "InvalidAestheticAttempt",
  AestheticsNotCompleted = "AestheticsNotCompleted",
  AestheticsNotPublic = "AestheticsNotPublic",
  AestheticsDuplicate = "AestheticsDuplicate",
  AestheticsMissing = "AestheticsMissing",
  AestheticsSolo = "AestheticsSolo",
  AestheticsConfused = "AestheticsConfused",
  AestheticsAlreadyExist = "AestheticsAlreadyExist",
  AestheticsServerRejected = "AestheticsServerRejected",
  AestheticsServerError = "AestheticsServerError",
  AestheticsServerDown = "AestheticsServerDown",
  AestheticsServerTimeout = "AestheticsServerTimeout",
  InvalidAPIKey = "InvalidAPIKey",
  WrongCredentials = "WrongCredentials",
  NotAdmin = "NotAdmin",
  NotModerator = "NotModerator",
  NotOwner = "NotOwner",
  NotPrivileged = "NotPrivileged",
  AnonForbidden = "AnonForbidden",
  AnonForbiddenWorker = "AnonForbiddenWorker",
  AnonForbiddenUserMod = "AnonForbiddenUserMod",
  NotTrusted = "NotTrusted",
  UntrustedTeamCreation = "UntrustedTeamCreation",
  UntrustedUnsafeIP = "UntrustedUnsafeIP",
  WorkerMaintenance = "WorkerMaintenance",
  WorkerFlaggedMaintenance = "WorkerFlaggedMaintenance",
  TooManySameIPs = "TooManySameIPs",
  WorkerInviteOnly = "WorkerInviteOnly",
  UnsafeIP = "UnsafeIP",
  TimeoutIP = "TimeoutIP",
  TooManyNewIPs = "TooManyNewIPs",
  KudosUpfront = "KudosUpfront",
  SharedKeyEmpty = "SharedKeyEmpty",
  InvalidJobID = "InvalidJobID",
  RequestNotFound = "RequestNotFound",
  WorkerNotFound = "WorkerNotFound",
  TeamNotFound = "TeamNotFound",
  FilterNotFound = "FilterNotFound",
  UserNotFound = "UserNotFound",
  DuplicateGen = "DuplicateGen",
  AbortedGen = "AbortedGen",
  RequestExpired = "RequestExpired",
  TooManyPrompts = "TooManyPrompts",
  NoValidWorkers = "NoValidWorkers",
  MaintenanceMode = "MaintenanceMode",
  TargetAccountFlagged = "TargetAccountFlagged",
  SourceAccountFlagged = "SourceAccountFlagged",
  FaultWhenKudosReceiving = "FaultWhenKudosReceiving",
  FaultWhenKudosSending = "FaultWhenKudosSending",
  TooFastKudosTransfers = "TooFastKudosTransfers",
  KudosTransferToAnon = "KudosTransferToAnon",
  KudosTransferToSelf = "KudosTransferToSelf",
  KudosTransferNotEnough = "KudosTransferNotEnough",
  NegativeKudosTransfer = "NegativeKudosTransfer",
  KudosTransferFromAnon = "KudosTransferFromAnon",
  InvalidAwardUsername = "InvalidAwardUsername",
  KudosAwardToAnon = "KudosAwardToAnon",
  NotAllowedAwards = "NotAllowedAwards",
  NoWorkerModSelected = "NoWorkerModSelected",
  NoUserModSelected = "NoUserModSelected",
  NoHordeModSelected = "NoHordeModSelected",
  NoTeamModSelected = "NoTeamModSelected",
  NoFilterModSelected = "NoFilterModSelected",
  NoSharedKeyModSelected = "NoSharedKeyModSelected",
  BadRequest = "BadRequest",
  Forbidden = "Forbidden",
  Locked = "Locked",
  ControlNetMismatch = "ControlNetMismatch",
  HiResFixMismatch = "HiResFixMismatch",
  TooManyLoras = "TooManyLoras",
  BadLoraVersion = "BadLoraVersion",
  TooManyTIs = "TooManyTIs",
  BetaAnonForbidden = "BetaAnonForbidden",
  BetaComparisonFault = "BetaComparisonFault",
  BadCFGDecimals = "BadCFGDecimals",
  BadCFGNumber = "BadCFGNumber",
  BadClientAgent = "BadClientAgent",
  SpecialMissingPayload = "SpecialMissingPayload",
  SpecialForbidden = "SpecialForbidden",
  SpecialMissingUsername = "SpecialMissingUsername",
  SpecialModelNeedsSpecialUser = "SpecialModelNeedsSpecialUser",
  SpecialFieldNeedsSpecialUser = "SpecialFieldNeedsSpecialUser",
  Img2ImgMismatch = "Img2ImgMismatch",
  TilingMismatch = "TilingMismatch",
  EducationCannotSendKudos = "EducationCannotSendKudos",
  InvalidPriorityUsername = "InvalidPriorityUsername",
}
